(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "../constants", "../request", "./events.schema"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("../constants"), require("../request"), require("./events.schema"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.constants, global.request, global.events);
    global.events = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _constants, _request, _events) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.track = void 0;
  /* eslint-disable no-param-reassign */

  var track = _exports.track = function track(payload) {
    /* a customer could potentially send these up if they're not using TypeScript */
    delete payload.userId;
    delete payload.email;
    return (0, _request.baseIterableRequest)({
      method: 'POST',
      url: _constants.ENDPOINTS.event_track.route,
      data: payload,
      validation: {
        data: _events.trackSchema
      }
    });
  };
});